import type React from 'react'
import Joyride, { ACTIONS, type CallBackProps, EVENTS, STATUS } from 'react-joyride'
import { useCoachOnboardingContext } from '../../contexts/CoachOnboardingContext'
import { useTheme } from '../../contexts/ThemeContext'

export const CoachOnboardingTour: React.FC = () => {
  const { run, steps, stepIndex, setStepIndex, setRun, completeOnboarding } = useCoachOnboardingContext()
  const { theme, actualTheme } = useTheme()

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { action, index, status, type } = data

    if (([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)) {
      // Tour finished or skipped - mark as completed
      completeOnboarding()
      setRun(false)
    } else if (([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND] as string[]).includes(type)) {
      // Update step index
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1)
      setStepIndex(nextStepIndex)
    }
  }

  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      continuous
      showProgress
      showSkipButton
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: theme.colors.primary,
          backgroundColor: theme.colors.surface,
          textColor: theme.colors.text,
          overlayColor: actualTheme === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.5)',
          arrowColor: theme.colors.surface,
          zIndex: 10000,
        },
        tooltip: {
          backgroundColor: theme.colors.surface,
          borderRadius: Number.parseInt(theme.borderRadius.md),
          fontSize: Number.parseInt(theme.typography.md),
          color: theme.colors.text,
        },
        tooltipContainer: {
          textAlign: 'left',
        },
        tooltipContent: {
          padding: theme.spacing.md,
          color: theme.colors.text,
        },
        tooltipTitle: {
          color: theme.colors.text,
          fontSize: Number.parseInt(theme.typography.lg),
          fontWeight: 600,
          marginBottom: theme.spacing.sm,
        },
        buttonNext: {
          backgroundColor: theme.colors.primary,
          color: theme.colors.textInverted,
          borderRadius: Number.parseInt(theme.borderRadius.sm),
          fontSize: Number.parseInt(theme.typography.sm),
          fontWeight: 600,
          padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        },
        buttonBack: {
          color: theme.colors.textMuted,
          fontSize: Number.parseInt(theme.typography.sm),
          marginRight: theme.spacing.sm,
        },
        buttonSkip: {
          color: theme.colors.textMuted,
          fontSize: Number.parseInt(theme.typography.sm),
        },
        beacon: {
          backgroundColor: theme.colors.primary,
        },
        beaconInner: {
          backgroundColor: theme.colors.primary,
        },
        beaconOuter: {
          backgroundColor: theme.colors.primary,
          border: `2px solid ${theme.colors.primary}`,
        },
      }}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Finish',
        next: 'Next',
        skip: 'Skip tour',
      }}
    />
  )
}
